// Navigation identifiers only. Never persist inputs, credentials, outputs or OAuth tokens.
export const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
export const publicToken = /^[A-Za-z0-9_-]{32}$/;
export function entryDestination(search: string, startParam = ''): string | null {
  const q = new URLSearchParams(search);
  const setup = q.get('activationAttemptId');
  if (setup && uuid.test(setup)) return `/solutions/setup/${setup}`;
  const intent = q.get('entryIntentId');
  if (intent && uuid.test(intent)) return `/solutions/intent/${intent}`;
  const raw = q.get('entry') ?? startParam;
  const token = raw.startsWith('pe_') ? raw.slice(3) : raw;
  if (publicToken.test(token)) return `/solutions/link/${token}`;
  if (q.has('entry') || startParam.startsWith('pe_')) return '/solutions/invalid';
  return null; // old login/link/source payloads are opaque
}
export function assetPath(value: string, listingId: string, version: number): string | null {
  const pattern = new RegExp(`^/api/marketplace/listings/${listingId}/demo-assets/[A-Za-z0-9][A-Za-z0-9_.-]{0,63}\\?version=${version}$`);
  return uuid.test(listingId) && Number.isSafeInteger(version) && version > 0 && pattern.test(value) ? value : null;
}
export function deliveryLabel(status: string): string {
  return ({ accepted: 'Доставлено', partial: 'Доставлено частично', pending: 'Доставка ожидает подтверждения', failed: 'Ошибка доставки', skipped_empty: 'Нет результата для доставки' } as Record<string, string>)[status] ?? 'Статус доставки неизвестен';
}
export function executionLabel(status: string): string {
  return ({pending:'Запуск ожидает очереди', running:'Выполняется', completed:'Выполнено', previewed:'Предпросмотр — запись ещё не выполнена', empty:'Завершено без полезного результата', failed:'Ошибка выполнения'} as Record<string,string>)[status] ?? 'Состояние требует проверки';
}
export async function copyPublicLink(url: string, clipboard?: Pick<Clipboard, 'writeText'>): Promise<boolean> {
  try { await clipboard?.writeText(url); return !!clipboard; } catch { return false; }
}
export function nextActionLabel(kind: string): string {
 return ({accept_consent:'Ознакомиться с условиями и принять согласие',connect:'Подключить свой аккаунт',configure:'Сохранить параметры и установить для себя',provide_input:'Передать собственные данные',confirm_write:'Проверить и подтвердить точную внешнюю операцию',view_result:'Посмотреть свой результат',none:'Проверить статус или продолжить настройку'} as Record<string,string>)[kind]??'Обновить состояние';
}
